import { render, staticRenderFns } from "./CrTable.vue?vue&type=template&id=18371e99"
import script from "./CrTable.vue?vue&type=script&lang=js"
export * from "./CrTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports